import PostPage from '../post_page';
import postPageStateManager from '../postpage_state_manager';

export default function(store) {
  return {
    path: '/pvw/:id/:section/:slug',
    component: PostPage,
    exact: true,
    strict: true,
    loadData: postPageStateManager(store)
  };
}
